export default function handleCreateObjectWithInStatement(data) {
  const newObject = { ...data };
  const objectOfIns = {};
  Object.entries(newObject).forEach(([key, value]) => {
    // STATUS_withIn as example
    if (Array.isArray(value) && key.match(/withIn/i)) {
      delete newObject[key];
      objectOfIns[key.split("_")[0]] = value;
    }
  });

  return { objectWithoutIns: newObject, objectWithIn: objectOfIns };
}
